import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["placeholder", "data-testid", "disabled", "id"]

import {ref} from "vue";
import TextFieldFormat from "../External/TextFieldFormat.vue";

interface Props {
  type: 'plain'|'html';
  placeholder: string;
  testId?: string;
  disabled?: boolean;
  labelId?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TextInput',
  props: /*@__PURE__*/_mergeModels({
    type: {},
    placeholder: {},
    testId: {},
    disabled: { type: Boolean },
    labelId: {}
  }, {
    "modelValue": {required: true},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {

const props = __props;
const model = _useModel<string>(__props, "modelValue");

const plainControl = ref<HTMLInputElement|null>(null);

function focus(): void {
  plainControl.value!.focus();
}

__expose({focus});

return (_ctx: any,_cache: any) => {
  return (props.type === 'plain')
    ? _withDirectives((_openBlock(), _createElementBlock("input", {
        key: 0,
        ref_key: "plainControl",
        ref: plainControl,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
        placeholder: props.placeholder,
        "data-testid": props.testId,
        disabled: props.disabled,
        id: props.labelId
      }, null, 8 /* PROPS */, _hoisted_1)), [
        [_vModelText, model.value]
      ])
    : (_openBlock(), _createBlock(TextFieldFormat, {
        key: 1,
        modelValue: model.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event)),
        placeholder: props.placeholder,
        "test-id": props.testId
      }, null, 8 /* PROPS */, ["modelValue", "placeholder", "test-id"]))
}
}

})